import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HomeService } from 'src/home/home.service'; // Asegúrate de que la ruta sea correcta
import { Provider, Providers } from 'src/models/Provider.interface';
import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { ProvidersService } from '../../providers/services/providers.service';
import { BillingService } from 'src/home/billing/services/billing.service';

@Component({
  selector: 'app-biller',
  templateUrl: './biller.component.html',
  styleUrls: ['./biller.component.css'],
  providers: [DatePipe],
})
export class BillerComponent implements OnInit {
  billingForm!: FormGroup;
  isLoading: boolean = false;

  providers: Provider[] = [];
  showAdvancedOptions: boolean = false;
  clientCodeValue: string | null = null;
  cifValue: string | null = null;
  constructor(
    private fb: FormBuilder,
    private homeService: HomeService,
    private billingService: BillingService,
    private providersService: ProvidersService,
    private datePipe: DatePipe,
    private router: Router,
  ) { }

  ngOnInit(): void {
    const today = new Date();

    const formattedToday = this.datePipe.transform(today, 'yyyy-MM-dd');

    this.billingForm = this.fb.group({
      providerId: ['', [Validators.required]],
      startDate: ['', [Validators.required]],
      endDate: ['', [Validators.required]],
      clientCode: ['', [Validators.pattern(/^\d+$/)]],
      cif: [''],
    });

    this.loadProviders();
  }

  loadProviders(): void {
    this.providersService.getListProviders(1).subscribe({
      next: (data: Providers) => {
        if (data && data.results) {
          // Verifica si data y data.results están definidos
          this.providers = data.results.filter(
            (provider) => provider.status === 'active'
          );
        } else {
          console.error('Error loading providers: Unexpected response format');
        }
      },
      error: (error) => console.error('Error loading providers:', error),
    });
  }
  confirmSubmit(): void {
    if (this.billingForm.valid) {
      const { providerId, startDate, endDate, clientCode, cif } =
        this.billingForm.value;

      const formattedStartDate = this.datePipe.transform(
        startDate,
        'dd-MM-yyyy'
      );
      const formattedEndDate = this.datePipe.transform(endDate, 'dd-MM-yyyy');

      const requestData = {
        providerId,
        startDate: formattedStartDate,
        endDate: formattedEndDate,
        clientCode: clientCode ? parseInt(clientCode, 10) : undefined,
        cif: cif || undefined,
      };

      this.isLoading = true;
      this.billingService.sendProviderBillingData(requestData).subscribe({
        next: (response) => {
          this.isLoading = false;
          Swal.fire({
            title: '¡Éxito!',
            text: `El proceso de facturación ha sido lanzado. El ID de proceso es: ${response.billingProcessId}`,
            icon: 'success',
            showCancelButton: true,
            confirmButtonText: 'Ver proceso de facturación',
            cancelButtonText: 'Cerrar',
          }).then((result) => {
            if (result.isConfirmed) {
              this.router.navigate(['home/billing-process']);
            }
          });
        },
        error: (error) => {
          this.isLoading = false;
          Swal.fire(
            'Error',
            'Hubo un problema al enviar tus datos. Por favor, inténtalo de nuevo.',
            'error'
          );
        },
      });
    } else {
      Swal.fire(
        'Atención',
        'Completa correctamente todos los campos requeridos.',
        'info'
      );
    }
  }

  clearFilters(): void {
    this.billingForm.reset({
      providerId: null,
      startDate: null,
      endDate: null,
      clientCode: null,
      cif: null,
    });
  }
  toggleAdvancedOptions(): void {
    this.showAdvancedOptions = !this.showAdvancedOptions;
  }


  onClientCodeChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.value) {
      this.billingForm.get('cif')?.disable();
    } else {
      this.billingForm.get('cif')?.enable();
    }
  }

  onCifChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.value) {
      this.billingForm.get('clientCode')?.disable();
    } else {
      this.billingForm.get('clientCode')?.enable();
    }
  }
}
